module.exports = __webpack_public_path__ + "img/kbank.cf7a16a5.png";